import { Button, Grid, Typography } from "@mui/material";
import { HashLink as Link } from "react-router-hash-link";
import { useContext } from "react";
import { SettingsContext } from "../../context/SettingsContext";

import beautyImg from "../../assets/industries/beauty/main-section.png";
import electronicImg from "../../assets/industries/electronic/main-section.png";
import fashionImg from "../../assets/industries/fashion/main-section.png";
import homeImg from "../../assets/industries/home/main-section.png";
import supermarketImg from "../../assets/industries/supermarket/main-section.png";
import babyImg from "../../assets/industries/baby/main-section.png";
import healthImg from "../../assets/industries/health/main-section.png";
import cultureImg from "../../assets/industries/culture/main-section.png";
import sportImg from "../../assets/industries/sport/main-section.png";
import motoImg from "../../assets/industries/moto/main-section.png";
import propertyImg from "../../assets/industries/property/main-section.png";
import artImg from "../../assets/industries/art/main-section.png";
import companyImg from "../../assets/industries/company/main-section.png";

const images = {
  beauty: beautyImg,
  electronic: electronicImg,
  fashion: fashionImg,
  home: homeImg,
  supermarket: supermarketImg,
  baby: babyImg,
  health: healthImg,
  culture: cultureImg,
  sport: sportImg,
  moto: motoImg,
  property: propertyImg,
  art: artImg,
  company: companyImg,
};

export default function MainSection() {
  const settings = useContext(SettingsContext);

  return (
    <Grid
      container
      sx={{
        color: "#FFF",
        backgroundImage: `url(${images[settings.industry]})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right top",
        backgroundSize: { xs: "cover", md: "70%", lg: "contain", xl: "34%" },
        marginBottom: "4rem",
      }}
      className="container-main-section"
    >
      <Grid item xs={12} md={6} lg={8} className="desc-main-section">
        <Grid container flexDirection={"column"}>
          <Typography variant="h2" fontWeight={"bold"}>
            {settings.title}
          </Typography>
          <Typography variant="body1" padding={"2rem 0rem"}>
            {settings.mainDescription}
          </Typography>
          <Grid container>
            <Button
              variant="outlined"
              sx={{ mr: 2 }}
              LinkComponent={Link}
              to="#offer"
              smooth
            >
              Oferta
            </Button>
            <Button
              variant="contained"
              LinkComponent={Link}
              to="#contact"
              smooth
            >
              Kontakt
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
